/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AppPermissionsEnum = {
    Global: 'Global',
    Local: 'Local',
    GlobalHost: 'Global_Host',
    GlobalHostMaintenance: 'Global_Host_Maintenance',
    GlobalHostSettings: 'Global_Host_Settings',
    GlobalHostTenants: 'Global_Host_Tenants',
    GlobalHostTenantsViewList: 'Global_Host_Tenants_ViewList',
    GlobalHostTenantsViewDetail: 'Global_Host_Tenants_ViewDetail',
    GlobalHostTenantsAdd: 'Global_Host_Tenants_Add',
    GlobalHostTenantsEdit: 'Global_Host_Tenants_Edit',
    GlobalHostTenantsDelete: 'Global_Host_Tenants_Delete',
    GlobalHostTenantsChangeFeatures: 'Global_Host_Tenants_ChangeFeatures',
    GlobalHostTenantsImpersonation: 'Global_Host_Tenants_Impersonation',
    GlobalRoles: 'Global_Roles',
    GlobalRolesViewList: 'Global_Roles_ViewList',
    GlobalRolesViewDetail: 'Global_Roles_ViewDetail',
    GlobalRolesAdd: 'Global_Roles_Add',
    GlobalRolesEdit: 'Global_Roles_Edit',
    GlobalRolesDelete: 'Global_Roles_Delete',
    GlobalAccounts: 'Global_Accounts',
    GlobalAccountsViewList: 'Global_Accounts_ViewList',
    GlobalAccountsViewDetail: 'Global_Accounts_ViewDetail',
    GlobalAccountsAdd: 'Global_Accounts_Add',
    GlobalAccountsEdit: 'Global_Accounts_Edit',
    GlobalAccountsDelete: 'Global_Accounts_Delete',
    GlobalTaskManagement: 'Global_TaskManagement',
    GlobalTaskManagementViewList: 'Global_TaskManagement_ViewList',
    GlobalTaskManagementViewDetail: 'Global_TaskManagement_ViewDetail',
    GlobalTaskManagementAdd: 'Global_TaskManagement_Add',
    GlobalTaskManagementEdit: 'Global_TaskManagement_Edit',
    GlobalTaskManagementDelete: 'Global_TaskManagement_Delete',
    GlobalJobConfigurations: 'Global_JobConfigurations',
    GlobalJobConfigurationsViewList: 'Global_JobConfigurations_ViewList',
    GlobalJobConfigurationsViewDetail: 'Global_JobConfigurations_ViewDetail',
    GlobalJobConfigurationsAdd: 'Global_JobConfigurations_Add',
    GlobalJobConfigurationsEdit: 'Global_JobConfigurations_Edit',
    GlobalJobConfigurationsDelete: 'Global_JobConfigurations_Delete',
    GlobalJobOccurrences: 'Global_JobOccurrences',
    GlobalJobOccurrencesViewList: 'Global_JobOccurrences_ViewList',
    GlobalJobOccurrencesViewDetail: 'Global_JobOccurrences_ViewDetail',
    GlobalJobOccurrencesDelete: 'Global_JobOccurrences_Delete',
    GlobalTaskTemplates: 'Global_TaskTemplates',
    GlobalTaskTemplatesView: 'Global_TaskTemplates_View',
    GlobalComments: 'Global_Comments',
    GlobalCommentsDeleteExternal: 'Global_Comments_DeleteExternal',
    GlobalProtocols: 'Global_Protocols',
    GlobalProtocolsViewList: 'Global_Protocols_ViewList',
    GlobalProtocolsViewDetail: 'Global_Protocols_ViewDetail',
    GlobalProtocolsAdd: 'Global_Protocols_Add',
    GlobalProtocolsEdit: 'Global_Protocols_Edit',
    GlobalProtocolsDelete: 'Global_Protocols_Delete',
    GlobalSchedules: 'Global_Schedules',
    GlobalSchedulesView: 'Global_Schedules_View',
    GlobalSchedulesEdit: 'Global_Schedules_Edit',
    GlobalSystem: 'Global_System',
    GlobalSystemSettings: 'Global_SystemSettings',
    GlobalSystemSettingsAccountSecurity: 'Global_SystemSettings_AccountSecurity',
    GlobalSystemSettingsUpdate: 'Global_SystemSettings_Update',
    GlobalSystemSettingsUpdateStart: 'Global_SystemSettings_Update_Start',
    GlobalSystemSettingsAdvancedSettings: 'Global_SystemSettings_AdvancedSettings',
    GlobalLicenses: 'Global_Licenses',
    GlobalLicensesViewDetail: 'Global_Licenses_ViewDetail',
    LocalMedicalSystems: 'Local_MedicalSystems',
    LocalMedicalSystemsViewList: 'Local_MedicalSystems_ViewList',
    LocalMedicalSystemsViewDetail: 'Local_MedicalSystems_ViewDetail',
    LocalMedicalSystemsAdd: 'Local_MedicalSystems_Add',
    LocalMedicalSystemsEdit: 'Local_MedicalSystems_Edit',
    LocalMedicalSystemsDelete: 'Local_MedicalSystems_Delete',
    LocalDosimetryAndQaEquipment: 'Local_DosimetryAndQaEquipment',
    LocalDosimetryAndQaEquipmentViewList: 'Local_DosimetryAndQaEquipment_ViewList',
    LocalDosimetryAndQaEquipmentViewDetail: 'Local_DosimetryAndQaEquipment_ViewDetail',
    LocalDosimetryAndQaEquipmentAdd: 'Local_DosimetryAndQaEquipment_Add',
    LocalDosimetryAndQaEquipmentEdit: 'Local_DosimetryAndQaEquipment_Edit',
    LocalDosimetryAndQaEquipmentDelete: 'Local_DosimetryAndQaEquipment_Delete',
    LocalResultManagement: 'Local_ResultManagement',
    LocalResultManagementViewDatasets: 'Local_ResultManagement_ViewDatasets',
    LocalResultManagementViewDetail: 'Local_ResultManagement_ViewDetail',
    LocalResultManagementReportManagement: 'Local_ResultManagement_ReportManagement',
    GlobalUnits: 'Global_Units',
    GlobalUnitsViewList: 'Global_Units_ViewList',
    GlobalUnitsViewDetail: 'Global_Units_ViewDetail',
    GlobalUnitsAdd: 'Global_Units_Add',
    GlobalUnitsEdit: 'Global_Units_Edit',
    GlobalUnitsDelete: 'Global_Units_Delete',
    GlobalEnumerations: 'Global_Enumerations',
    GlobalEnumerationsViewList: 'Global_Enumerations_ViewList',
    GlobalEnumerationsViewDetail: 'Global_Enumerations_ViewDetail',
    GlobalEnumerationsAdd: 'Global_Enumerations_Add',
    GlobalEnumerationsEdit: 'Global_Enumerations_Edit',
    GlobalEnumerationsDelete: 'Global_Enumerations_Delete',
    GlobalQuantities: 'Global_Quantities',
    GlobalQuantitiesViewList: 'Global_Quantities_ViewList',
    GlobalQuantitiesViewDetail: 'Global_Quantities_ViewDetail',
    GlobalQuantitiesAdd: 'Global_Quantities_Add',
    GlobalQuantitiesEdit: 'Global_Quantities_Edit',
    GlobalQuantitiesDelete: 'Global_Quantities_Delete',
    GlobalDashboards: 'Global_Dashboards',
    GlobalDashboardsView: 'Global_Dashboards_View',
    GlobalDashboardsAdd: 'Global_Dashboards_Add',
    GlobalDashboardsEdit: 'Global_Dashboards_Edit',
    GlobalDashboardsDelete: 'Global_Dashboards_Delete',
    P4Lic: 'P4Lic',
    P4LicPlans: 'P4Lic_Plans',
    P4LicPlansBasic: 'P4Lic_Plans_Basic',
    P4LicPlansStandard: 'P4Lic_Plans_Standard',
    P4LicPlansPro: 'P4Lic_Plans_Pro',
    P4LicOptions: 'P4Lic_Options',
    P4LicOptionsLocationManagement: 'P4Lic_Options_LocationManagement',
    P4LicOptionsDeploymentServices: 'P4Lic_Options_DeploymentServices',
    P4LicOptionsDosimetrySchoolTraining: 'P4Lic_Options_DosimetrySchoolTraining'
} as const;
export type AppPermissionsEnum = typeof AppPermissionsEnum[keyof typeof AppPermissionsEnum];


export function AppPermissionsEnumFromJSON(json: any): AppPermissionsEnum {
    return AppPermissionsEnumFromJSONTyped(json, false);
}

export function AppPermissionsEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppPermissionsEnum {
    return json as AppPermissionsEnum;
}

export function AppPermissionsEnumToJSON(value?: AppPermissionsEnum | null): any {
    return value as any;
}

/**
 * Check if a given object implements the AppPermissionsEnum interface.
 */
 export function instanceOfAppPermissionsEnum(value: any): value is AppPermissionsEnum {
    return Object.values(AppPermissionsEnum).includes(value)
}

